<template>
  <div
    class="spinner-border"
    :class="largeSpinner ? { size: largeSpinner } : 'spinner-border-sm'"
    role="status"
  >
    <span class="visually-hidden">Loading...</span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "LoadingComponent",

  props: {
    largeSpinner: {
      required: true,
      type: Boolean,
    },
  },
});
</script>

<style scoped>
div {
  margin-right: 2px;
}

.size {
  width: 5rem;
  height: 5rem;
}
</style>
